import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../context/ThemeContext';
import { useAuth } from '../../context/AuthContext';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiSun, FiMoon, FiMenu, FiBell, FiUser, FiLogOut, FiXCircle } = FiIcons;

export default function Header({ toggleSidebar }) {
  const { theme, toggleTheme } = useTheme();
  const { user, tenant, logout, isImpersonating, exitTenant } = useAuth();
  const navigate = useNavigate();

  const handleExitTenant = () => {
    exitTenant();
    navigate('/admin/tenants');
  };

  return (
    <>
      {isImpersonating && (
        <div className="sticky top-0 z-40 flex items-center justify-between bg-amber-500 px-4 py-2 text-sm font-semibold text-amber-950">
          <span>Viewing as OWNER of {tenant?.company_name}</span>
          <button
            onClick={handleExitTenant}
            className="inline-flex items-center gap-1 rounded-md bg-amber-600 px-3 py-1 text-xs font-bold text-white hover:bg-amber-700 transition-colors"
          >
            <SafeIcon icon={FiXCircle} className="h-4 w-4" />
            Exit Tenant
          </button>
        </div>
      )}
      <header className="sticky top-0 z-30 flex h-16 items-center gap-x-4 border-b border-slate-200 bg-white px-4 shadow-sm dark:border-slate-800 dark:bg-slate-900 sm:gap-x-6 sm:px-6 lg:px-8">
        <button type="button" className="-m-2.5 p-2.5 text-slate-700 lg:hidden" onClick={toggleSidebar}>
          <span className="sr-only">Open sidebar</span>
          <SafeIcon icon={FiMenu} className="h-6 w-6" aria-hidden="true" />
        </button>

        <div className="flex flex-1 gap-x-4 self-stretch lg:gap-x-6">
          <div className="flex flex-1 items-center">
             {tenant && (
               <div className="flex flex-col">
                 <h1 className="text-sm font-semibold text-slate-900 dark:text-white">{tenant.company_name}</h1>
                 <span className="text-xs text-slate-500 dark:text-slate-400">FFL: {tenant.ffl_number}</span>
               </div>
             )}
          </div>
          <div className="flex items-center gap-x-4 lg:gap-x-6">
            <button onClick={toggleTheme} className="-m-2.5 p-2.5 text-slate-400 hover:text-slate-500">
              <span className="sr-only">Toggle theme</span>
              {theme === 'dark' ? <SafeIcon icon={FiSun} className="h-5 w-5" /> : <SafeIcon icon={FiMoon} className="h-5 w-5" />}
            </button>

            <div className="h-6 w-px bg-slate-200 dark:bg-slate-700" aria-hidden="true" />

            <div className="flex items-center gap-x-4 lg:gap-x-6">
              <div className="flex items-center gap-x-2">
                <span className="hidden lg:flex lg:items-center">
                  <span className="ml-4 text-sm font-semibold leading-6 text-slate-900 dark:text-white" aria-hidden="true">{user?.name || 'User'}</span>
                </span>
                <button
                  onClick={logout}
                  className="rounded-full bg-slate-50 p-1.5 text-slate-500 hover:bg-slate-100 dark:bg-slate-800 dark:hover:bg-slate-700"
                  title="Logout"
                >
                  <SafeIcon icon={FiLogOut} className="h-4 w-4" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}
